import { URL_PIC } from "../service/Config";

const personEmpty = "assets/layout/images/man.jpg";
const ImagesEmpty = "assets/layout/images/noimage.jpg";

export const srcPersonFile = (path, emty = personEmpty) => {
    const config = {
        src: path ? URL_PIC(path) : personEmpty,
        onError: (e) => {
            e.target.onerror = null;
            e.target.src = emty;
        },
    };
    return config;
};

export const srcImagesFile = (path, emty = ImagesEmpty) => {
    const config = {
        src: path ? URL_PIC(path) : ImagesEmpty,
        onError: (e) => {
            e.target.onerror = null;
            e.target.src = emty;
        },
    };
    return config;
};

export const srcFile = (path, emty = null) => {
    const config = {
        src: path ? URL_PIC(path) : null,
        onError: (e) => {
            e.target.onerror = null;
            e.target.src = emty;
        },
    };
    return config;
};
